import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent, DialogConfig, DialogRef } from '@siemens/component-lib';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfirmationDialogData } from '../../interfaces/miscellaneous/ConfirmationDialogData';

@Component({
    selector: 'app-confirmation-dialog',
    imports: [ButtonComponent, TranslatePipe],
    templateUrl: './confirmation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
    private dialogRef = inject(DialogRef);
    protected dialogConfig: DialogConfig<ConfirmationDialogData> = inject(DialogConfig<ConfirmationDialogData>);

    public onConfirm(): void {
        this.dialogRef.close(true);
    }

    public onCancel(): void {
        this.dialogRef.close(false);
    }
}
